/** Z-index for portaled menus so they render above the routes drawer (z-[9999]). */
export const ROUTE_MENU_CLASS_NAME = 'z-[10000]';

export const STOP_BADGE_LABELS = {
  nextUp: 'Next Up',
  active: 'Active Stop',
  visited: 'Visited',
} as const;
